import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    // Se não estiver logado, redireciona para login
    return <Navigate to="/Login" />;
  }

  return children;
};

export default PrivateRoute;
